var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"moduleheader"},[_c('p',{staticClass:"tit"},[_vm._v(_vm._s(_vm.moduleheader.text)+" "),_c('span',[_vm._v(_vm._s(_vm.moduleheader.note))])]),(_vm.moduleheader.flag)?_c('p',{staticClass:"more",on:{"click":function($event){return _vm.skip(_vm.moduleheader.age)}}},[_vm._v("更多")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }